import { useEffect, useState } from 'react';
import { useSidebarSession } from '../bridge/session';

/**
 * Whether to show failures the user cannot fix. Read when a view mounts, so a
 * change in Settings applies on returning to the page view; a failed read
 * leaves them hidden.
 */
export function useShowTechnicalProblems(): boolean {
  const { client } = useSidebarSession();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let active = true;
    void client
      .request('settings.get', {})
      .then((preferences) => {
        if (active) setShow(preferences.showTechnicalProblems === true);
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [client]);

  return show;
}
